/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupUserAddableDtoPage } from '../../models/group-user-addable-dto-page';

export interface ListGroupUsersAddable$Params {
  groupId: string;
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'firstName' | '-firstName' | 'lastName' | '-lastName' | 'color' | '-color'>;
}

export function listGroupUsersAddable(http: HttpClient, rootUrl: string, params: ListGroupUsersAddable$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupUserAddableDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listGroupUsersAddable.PATH, 'get');
  if (params) {
    rb.query('groupId', params.groupId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupUserAddableDtoPage>;
    })
  );
}

listGroupUsersAddable.PATH = '/v0/groups/group-users-addable';
